var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.6212,
    transform: "translate(0 0.378784)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4377 14.9597L21.92 12.3494C22.0267 12.2694 22.0267 12.1094 21.92 12.0294L18.4377 9.41912C18.3058 9.32028 18.1177 9.41436 18.1177 9.57913V11.4369L2.2 11.4369C2.08956 11.4369 2 11.5264 2 11.6369V12.7419C2 12.8524 2.08956 12.9419 2.2 12.9419L18.1177 12.9419V14.7996C18.1177 14.9644 18.3058 15.0585 18.4377 14.9597Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselbutton);
export default __webpack_public_path__ + "static/media/carouselbutton.6ebeffa368350267a18dcefb9ca9b5eb.svg";
export { ForwardRef as ReactComponent };